$(document).ready(function(){
 // $(window).scrollTop(0);
  
  // nav-item animation
  let tl1 = gsap.timeline({delay: .2});
  tl1.from(".mobile-nav > li",{
    opacity: 0,
    x: -100,
    stagger: .2
  });
  tl1.pause();  
  $(".js-mobile-nav-toggle").click(function(){
    tl1.play();
  });
  $(".closemmn").click(function(){
    tl1.reverse();
  });
  //end

  // collection list animation
  let cardWrapper = $(".anim-card__wrapper");
  cardWrapper.each((i, wrapper)=>{
    gsap.from($(wrapper).find(".anim-card"), {
      scrollTrigger:{
        trigger: wrapper,
        start: "top 80%",
        end:"top 70%",
        toggleActions: "play none none none",
        onEnter: ()=>{
          // console.log("Visible cards");
        }
      },
      opacity: 0,
      y:100,
      stagger: .2
    })
  });
  // end

  // For single product page current variant should be highlighted
  if($('.related-product')){
    let currentUrl = window.location.href;
    let relatedProductsUrl = $('.related-product');
  
    relatedProductsUrl.each((i, prod)=>{
      if(currentUrl == prod.href){
        $(prod).css("border-color", "black");
      }
    });    
  }
  // end







  
  
})